import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectProduct, setVizLoading } from '../../../../store/visualizerSlice';
import ProductList from '../../ProductList/ProductList';
import StepNavigation from '../../StepNavigation/StepNavigation';
import styles from './ExtWindowTrim.module.css';

export default function ExtWindowTrim({ 
    surfaceName = 'Window Trim', 
    stepIndex,
    room = '',
    onViewAllApplied, 
    onNext, 
    onPrevious 
}) {
    const dispatch = useDispatch();
    const stepSelections = useSelector(state => state.visualizer.stepSelections);
    const [selectedProduct, setSelectedProduct] = useState(null);

    // Selection key: StepName_Room
    const selectionKey = `ExtWindowTrim_${room}`;

    // Restore selection from Redux on mount
    useEffect(() => {
        const savedSelection = stepSelections[selectionKey];
        if (savedSelection?.product) {
            setSelectedProduct(savedSelection.product);
        }
    }, [stepSelections, selectionKey]);

    const handleProductSelect = (product) => {
        setSelectedProduct(product);
        
        console.log('ExtWindowTrim - Product selected:', product.color || product.name);
        console.log('ExtWindowTrim - Applying to surface:', surfaceName);
        
        dispatch(selectProduct({
            product,
            surfaceName,
            stepIndex,
            selectionKey
        }));
        
        const chamViz = document.getElementById('chamViz');
        if (!chamViz) {
            console.error('ExtWindowTrim - chamViz element not found');
            return;
        }

        if (!product.id) {
            console.error('ExtWindowTrim - Product has no ID');
            return;
        }

        console.log('ExtWindowTrim - Applying product ID:', product.id);
        dispatch(setVizLoading(true));
        
        chamViz.applyByFilter(
            product.id,
            "",
            function(newSel) {
                if (this.name === surfaceName) {
                    return newSel;
                }
                return this.sel;
            },
            true
        );
    };

    const handleViewAllApplied = () => {
        if (onViewAllApplied) {
            onViewAllApplied();
        }
    };

    return (
        <div className={styles.container}>
            <StepNavigation
                title="Window Trim"
                onNext={onNext}
                onPrevious={onPrevious}
                onViewAllApplied={handleViewAllApplied}
            />

            <div className={styles.productListContainer}>
                <ProductList
                    seriesId="9747"
                    thumbSize="256"
                    onProductSelect={handleProductSelect}
                    titleAttribute="color"
                    descriptionAttribute="name"
                    gridClassName={styles.productGrid}
                    selectedId={selectedProduct?.id}
                />
            </div>
        </div>
    );
}

ExtWindowTrim.propTypes = {
    surfaceName: PropTypes.string,
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
